import { render, staticRenderFns } from "./ETabelaAulasPorEtapa.vue?vue&type=template&id=1fe1b4e4"
import script from "./ETabelaAulasPorEtapa.vue?vue&type=script&lang=js"
export * from "./ETabelaAulasPorEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports